<template>
  <brb-btn
    class="p-0 m-0"
    :href="src ? $config.files.createStaticUrl(src) : '#'"
    target="_blank"
    variant="link"
  >
    <brb-media
      :src="src"
      v-bind="$attrs"
      :width="width"
      :height="height"
      :class="[
        { 'img-thumbnail': !noThumbnail },
        { 'img-circle': circle },
        thumbnailClass
      ]"
      :style="thumbnailStyle"
    />
  </brb-btn>
</template>

<script>
export default {
  name: 'BrbImagePreview',
  inheritAttrs: false,
  props: {
    src: String,
    width: {
      type: [String, Number],
      default: 50
    },
    height: {
      type: [String, Number],
      default: 50
    },
    thumbnailClass: [String, Array, Object],
    thumbnailStyle: [String, Array, Object],
    circle: Boolean,
    noThumbnail: Boolean
  }
}
</script>
